import { Button, Card, CardBody, CardHeader, Divider, Select, SelectItem, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea } from "@nextui-org/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import useSWR from "swr";
import { getSelectFetcher, getSelectProvinceFetcher, patchFetcherWithoutId, postFetcher } from "../../../../../services/api";
import { dirtyInput, formatDate, hasValidRole, hasValidStatus, isResponseErrorObject } from "../../../../../services/helpers";
import Tembusan from "./Tembusan";
import useAuth from "../../../../../hooks/useAuth";
import RolesAccess from "../../../../../enums/roles";
import StatusRekomendasi from "../../../../../enums/statusRekomendasi";
import ModalAlert from "../../../../elements/ModalAlert";
import TipeSurat from "../../../../../enums/tipeSurat";
import { month } from "../../../../../enums/month";
import { ArrowPathIcon, CheckIcon, PaperAirplaneIcon } from "@heroicons/react/24/outline";
import ControlledReactSelect from "../../../../elements/ControlledReactSelect";
import { draftRecomendationLetter } from "../../../../../services/validation/recomendation.validation";
import ControlledInput from "../../../../elements/ControlledInput";

export default function Draft({ data, mutate }) {
  const today = new Date();
  const defaultMonth = today.getMonth(); // 0-based index
  const defaultYear = today.getFullYear().toString();
  const defaultTanggalBerakhir = new Date(today); // Clone the current date
  defaultTanggalBerakhir.setFullYear(today.getFullYear() + 5);
  const { user, roles } = useAuth();
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);
  const [onOpenChangeModalForm, setOnOpenChangeModalForm] = useState(false);
  const [onCloseForm, setOnCloseForm] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting, dirtyFields },
  } = useForm({
    resolver: yupResolver(draftRecomendationLetter),
    defaultValues: {
      nomorSurat: data?.draftSurat?.nomorSurat,
      tipeSurat: data?.draftSurat?.tipeSurat,
      bulan: data?.draftSurat?.bulanSurat ?? defaultMonth,
      tahun: data?.draftSurat?.tahunSurat ?? defaultYear,
      tanggalSurat: formatDate(data?.draftSurat?.tanggalSurat),
      tanggalSuratPerusahaan: formatDate(data?.tanggalSuratPerusahaan),
      nomorSuratPerusahaan: data?.nomorSuratPerusahaan || "",
      tanggalSuratRekomendasi: formatDate(data?.tanggalSuratRekomendasi),
      nomorSuratRekomendasi: data?.nomorSuratRekomendasi || "",
      tanggalBerlaku: formatDate(data?.tanggalBerlaku ?? today),
      tanggalBerakhir: formatDate(data?.tanggalBerakhir ?? defaultTanggalBerakhir),
      pejabatId: data.draftSurat?.pejabat?.id,
      provinceId: data?.provinceDilewati.map((provinsi) => provinsi.id),
    },
  });
  // Modal control state
  const [isOpenModalSubmitDirecture, setIsOpenModalSubmitDirecture] = useState(false);
  const [isOpenModalSelesaiAlert, setIsOpenModalSelesaiAlert] = useState(false);
  const [isOpenModalSpionamAlert, setIsOpenModalSpionamAlert] = useState(false);
  const { data: dataPejabat, isLoading: isLoadingPejabat } = useSWR("/api/data-master/pejabat?limit=100", getSelectFetcher);
  const { data: province, isLoading: isLoadingProvince } = useSWR("/api/location/provinces", getSelectProvinceFetcher);

  // Function to confirm and submit the SK
  async function onValidate(applicationId) {
    try {
      const data = {
        applicationId: applicationId,
        status: StatusRekomendasi.DRAFT_SK_TANDA_TANGAN_DIREKTUR,
        userId: user.userId,
      };
      await patchFetcherWithoutId("/api/rekom/permohonan/status", data);
      setIsOpenModalSubmitDirecture(false);
      mutate();
      toast.success("Draf SK Rekomendasi selesai!");
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
      setIsOpenModalSubmitDirecture(false);
    }
  }

  // Function to confirm and submit the SK
  async function onValidateSelesai(applicationId) {
    try {
      const data = {
        applicationId: applicationId,
        // status: StatusRekomendasi.MENGIRIM_SK_REKOMENDASI_B3_KE_SPIONAM,
        status: StatusRekomendasi.SELESAI,
        userId: user.userId,
      };
      await patchFetcherWithoutId("/api/rekom/permohonan/status", data);
      setIsOpenModalSubmitDirecture(false);
      mutate();
      toast.success("Draf SK Rekomendasi selesai!");
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
      setIsOpenModalSubmitDirecture(false);
    }
  }

  // Function to confirm and submit the SK
  async function onValidateKirimSpionam(applicationId) {
    try {
      await postFetcher(`/api/rekom/permohonan/send/spionam/${applicationId}`);
      setIsOpenModalSpionamAlert(false);
      mutate();
      toast.success("Draf SK Rekomendasi selesai!");
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
      setIsOpenModalSpionamAlert(false);
    }
  }

  // Function to confirm and submit the SK
  async function onValidateKembaliKePIC(applicationId, formData) {
    try {
      // const data = {
      //     applicationId: applicationId,
      //     status: StatusRekomendasi.PEMBUATAN_DRAFT_SK,
      //     userId: user.userId
      // }
      // await patchFetcherWithoutId('/api/rekom/permohonan/status', data);
      // setIsOpenModalSubmitDirecture(false);
      // mutate()
      console.log(applicationId, formData);
      toast.success("Draf SK Dikembalikan Ke PIC Rekomendasi!");
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
      setIsOpenModalSubmitDirecture(false);
    }
  }

  async function onSubmit(formData) {
    try {
      const filteredData = dirtyInput(dirtyFields, formData);
      filteredData.draftId = data?.draftSurat?.id;
      if (data?.tanggalBerlaku) filteredData.tanggalBerlaku = data?.tanggalBerlaku;
      if (data?.tanggalBerakhir) filteredData.tanggalBerakhir = data?.tanggalBerakhir;
      if (filteredData.bulan) filteredData.bulan = formData?.bulan;
      await patchFetcherWithoutId("/api/rekom/permohonan/draft-surat", filteredData);
      mutate();
      toast.success("Draft SK berhasil diubah!");
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
    }
  }

  const hasUnsavedChanges = Object.keys(dirtyFields).length > 0;

  return (
    <div className="flex flex-row gap-4 py-3">
      {hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN]) && (
        <div className="w-full md:w-2/5">
          <Tembusan existingTembusan={data} />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className={hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN]) ? "w-full md:w-3/5" : "w-full"}>
        <Card radius="sm" className="h-full">
          <CardHeader>
            <div className="flex flex-col">
              <span className="text-md">Draft SK</span>
              {hasUnsavedChanges && <span className="text-red-500 text-xs">Perubahan belum disimpan</span>}
            </div>
            {hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN]) && hasValidStatus(data?.status, [StatusRekomendasi.PEMBUATAN_DRAFT_SK]) && (
              <div className="ml-auto">
                <Button
                  isDisabled={hasValidStatus(data?.status, [StatusRekomendasi.PEMBUATAN_DRAFT_SK]) ? false : true}
                  onClick={() => setIsOpenModalSubmitDirecture(true)} // Open the modal when clicked
                  color="warning"
                  size="sm"
                  startContent={<ArrowPathIcon className="size-4" />}
                >
                  Submit Draft SK Ke Direktur
                </Button>
              </div>
            )}
            {hasValidRole(roles, [RolesAccess.DIREKTUR, RolesAccess.SUPER_ADMIN]) && hasValidStatus(data?.status, [StatusRekomendasi.DRAFT_SK_TANDA_TANGAN_DIREKTUR]) && (
              <div className="ml-auto">
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setIsOpenModalSelesaiAlert(true)} // Open the modal when clicked
                  className="ml-4"
                  startContent={<CheckIcon className="size-4" />}
                >
                  Pembuatan SK Selesai
                </Button>
              </div>
            )}

            {hasValidRole(roles, [RolesAccess.DIREKTUR, RolesAccess.SUPER_ADMIN]) && hasValidStatus(data?.status, [StatusRekomendasi.MENGIRIM_SK_REKOMENDASI_B3_KE_SPIONAM]) && (
              <div className="ml-auto">
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setIsOpenModalSpionamAlert(true)} // Open the modal when clicked
                  className="ml-4"
                  startContent={<PaperAirplaneIcon className="size-4" />}
                >
                  Kirim Spionam
                </Button>
              </div>
            )}
          </CardHeader>
          <Divider />
          <CardBody>
            <div className="grid grid-cols-2 gap-3 mb-5">
              <ControlledInput control={control} label="Tipe Surat" name="tipeSurat" isDisabled={true} isRequired={true} />
              <ControlledReactSelect
                control={control}
                name="pejabatId"
                label="Pejabat"
                options={dataPejabat}
                isLoading={isLoadingPejabat}
                menuPosition="absolute"
                isDisabled={data.status !== StatusRekomendasi.PEMBUATAN_DRAFT_SK || !hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN])}
              />
              <Select
                {...register("bulan")}
                variant="faded"
                label="Bulan"
                placeholder="Pilih"
                labelPlacement="outside"
                color={errors.bulan ? "danger" : "default"}
                isDisabled={data.status !== StatusRekomendasi.PEMBUATAN_DRAFT_SK || !hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN])}
                isInvalid={errors.bulan}
                errorMessage={errors.bulan && errors.bulan.message}
              >
                {month.map((item, index) => (
                  <SelectItem key={index} value={index}>
                    {item}
                  </SelectItem>
                ))}
              </Select>
              <ControlledInput
                control={control}
                label="Tahun"
                name="tahun"
                isRequired={true}
                isDisabled={data.status !== StatusRekomendasi.PEMBUATAN_DRAFT_SK || !hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN])}
              />
              <ControlledInput control={control} label="Nomor Surat Perusahaan" name="nomorSuratPerusahaan" isDisabled={true} />
              <ControlledInput control={control} label="Tanggal Surat Perusahaan" name="tanggalSuratPerusahaan" isDisabled={true} isRequired={true} type="date" />
              {data.tipeSurat && (data.tipeSurat === TipeSurat.PENAMBAHAN_JENIS_B3 || data.tipeSurat === TipeSurat.PENAMBAHAN_KENDARAAN || data.tipeSurat === TipeSurat.PERPANJANGAN) && (
                <>
                  <ControlledInput control={control} label="Nomor Surat Rekomendasi" name="nomorSuratRekomendasi" isDisabled={true} isRequired={true} />
                  <ControlledInput control={control} label="Tanggal Surat Rekomendasi" name="tanggalSuratRekomendasi" isRequired={true} isDisabled={true} type="date" />
                </>
              )}
              <ControlledInput
                control={control}
                label="Berlaku Dari"
                name="tanggalBerlaku"
                isDisabled={data.status !== StatusRekomendasi.PEMBUATAN_DRAFT_SK || !hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN])}
                type="date"
                isRequired
              />
              <ControlledInput
                control={control}
                label="Sampai"
                name="tanggalBerakhir"
                isDisabled={data.status !== StatusRekomendasi.PEMBUATAN_DRAFT_SK || !hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN])}
                type="date"
                isRequired
              />
              {hasValidRole(roles, [RolesAccess.DIREKTUR, RolesAccess.SUPER_ADMIN]) && (
                <>
                  <ControlledInput
                    control={control}
                    label="Nomor Surat"
                    name="nomorSurat"
                    isDisabled={hasValidStatus(data?.status, [StatusRekomendasi.PEMBUATAN_DRAFT_SK, StatusRekomendasi.SELESAI, StatusRekomendasi.DITOLAK, StatusRekomendasi.MENGIRIM_SK_REKOMENDASI_B3_KE_SPIONAM])}
                    isRequired
                  />
                  <ControlledInput
                    control={control}
                    label="Tanggal Surat"
                    name="tanggalSurat"
                    isRequired={true}
                    isDisabled={hasValidStatus(data?.status, [StatusRekomendasi.PEMBUATAN_DRAFT_SK, StatusRekomendasi.SELESAI, StatusRekomendasi.DITOLAK, StatusRekomendasi.MENGIRIM_SK_REKOMENDASI_B3_KE_SPIONAM])}
                    type="date"
                  />
                </>
              )}

              {hasValidRole(roles, [RolesAccess.PIC_REKOMENDASI, RolesAccess.SUPER_ADMIN]) && data?.tipeSurat !== TipeSurat.PENAMBAHAN_JENIS_B3 && (
                <div className="col-span-2">
                  <ControlledReactSelect control={control} name={`provinceId`} label="Pilih Provinsi Dilewati" options={province} isLoading={isLoadingProvince} isMulti isDisabled={data.status !== StatusRekomendasi.PEMBUATAN_DRAFT_SK} />
                </div>
              )}
            </div>
            <div className="flex items-center gap-2">
              <Button
                isDisabled={isSubmitting || Object.keys(dirtyFields).length === 0 || data?.isProcessed == false || hasValidStatus(data?.status, [StatusRekomendasi.SELESAI, StatusRekomendasi.DITOLAK, StatusRekomendasi.MENUNGGU_DI_PROSES])}
                isLoading={isSubmitting}
                type="submit"
                color="primary"
              >
                Simpan
              </Button>
              {/* {hasValidRole(roles, [RolesAccess.DIREKTUR, RolesAccess.SUPER_ADMIN]) &&  ![StatusRekomendasi.SELESAI, StatusRekomendasi.DITOLAK, StatusRekomendasi.VALIDASI_PEMOHONAN, StatusRekomendasi.PEMBUATAN_DRAFT_SK].includes(data.status)
                            && (
                                <Button color='danger' onClick={() => setIsOpenModalForm(true)}>
                                    Kembalikan SK Ke PIC Rekomendasi
                                </Button>
                            )} */}
            </div>
          </CardBody>
        </Card>
      </form>

      {/* ModalAlert for submitting the SK */}
      <ModalAlert
        heading="Submit Draft SK?"
        description="Pastikan semua data dan file sudah valid sebelum dikirim ke direktur."
        buttonSubmitText="Ya, Kirim"
        icon="warning"
        onSubmit={() => onValidate(data?.id)} // Pass draft ID to the validation function
        isOpen={isOpenModalSubmitDirecture}
        onOpenChange={setIsOpenModalSubmitDirecture}
      />

      {/* ModalAlert for submitting the SK */}
      <ModalAlert
        heading="Submit Draft SK?"
        description="Pastikan semua data dan file sudah valid sebelum SK dinyatakan Selesai."
        buttonSubmitText="Ya"
        icon="warning"
        onSubmit={() => onValidateSelesai(data?.id)} // Pass draft ID to the validation function
        isOpen={isOpenModalSelesaiAlert}
        onOpenChange={setIsOpenModalSelesaiAlert}
      />

      {/* ModalAlert for submitting the SK */}
      <ModalAlert
        heading="Kirim SK Ke Spionam?"
        description="Pastikan semua data dan file sudah valid sebelum SK dikirim ke Spionam."
        buttonSubmitText="Ya"
        icon="warning"
        onSubmit={() => onValidateKirimSpionam(data?.id)} // Pass draft ID to the validation function
        isOpen={isOpenModalSpionamAlert}
        onOpenChange={onValidateKirimSpionam}
      />

      <Modal isOpen={isOpenModalForm} onOpenChange={onOpenChangeModalForm} onClose={onCloseForm} isDismissable={false} isKeyboardDismissDisabled={false}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>Mengembalikan SK Ke PIC Rekomendasi</ModalHeader>
              <ModalBody>
                <form onSubmit={onValidateKembaliKePIC()}>
                  <div className="flex flex-col gap-3 mb-6">
                    <Textarea
                      {...register("notes", {
                        required: true,
                      })}
                      isRequired={true}
                      variant="faded"
                      type="text"
                      label="Catatan"
                      color={errors.validationNotes ? "danger" : "default"}
                      isInvalid={errors.validationNotes}
                      errorMessage={errors.validationNotes && errors.validationNotes.message}
                    />
                  </div>
                  <div className="flex items-center gap-1">
                    <Button isLoading={isSubmitting} isDisabled={isSubmitting} type="submit" color="primary">
                      Simpan
                    </Button>
                    <Button isDisabled={isSubmitting} color="danger" variant="faded" onPress={onClose}>
                      Batal
                    </Button>
                  </div>
                </form>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
}
